import React, { Component } from 'react';
import DateTime from 'react-datetime';

import './../../../node_modules/react-datetime/css/react-datetime.css';

import Core from './../../Core/Core';

class UserForm extends Component<Props,State>
{
    constructor(props)
    {
        super(props);
        this.state = {
            dealerships: []
        };

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
        this.handleDealerships = this.handleDealerships.bind(this);

        this.DateTime = React.createRef();
    }
    
    componentDidMount(){
        Core.Instance.Request(Core.Address + 'Dealership', null, 'GET').then((json) => {
            this.setState({
                dealerships: json != null ? json : [],
            });
        });
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    handleDealerships(event)
    {
        let dealershipsList = this.props.user.dealerships == null ? [] : this.props.user.dealerships.split(";");
        const index = dealershipsList.indexOf(event.target.name);
        if(event.target.checked === true){
            //Add dealership
            if (index === -1) {
                dealershipsList.push(event.target.name);
            }
        }else{
            //Remove dealership
            if (index > -1) {
                dealershipsList.splice(index, 1);
            }
        }

        let evt = {
            "target" : {
                "name" : 'dealerships',
                "value" : dealershipsList.join(';')
            } 
        }
        
        this.onChange(evt);
    }

    render()
    {
        let dealershipsList = this.props.user.dealerships == null ? [] : this.props.user.dealerships.split(";");
        let dealerships = this.state.dealerships.map((e) => {
            return (
                <div className="form-check" key={e.id}>
                    <input className="form-check-input" type="checkbox" name={e.name} checked={ dealershipsList.includes(e.name) } onClick={ this.handleDealerships } key={'dealership-'+e.id} id={'dealership-'+e.id}/>
                    <label className="form-check-label" htmlFor={'dealership-'+e.id}>{e.name}</label>
                </div>
            );
        });
        return (
            <div className="fade modal show" id="addUserModal" tabIndex="-1" role="dialog" aria-labelledby="addUserModalLabel" aria-modal="true">
            <div className="modal-dialog modal-full-height modal-right" role="document">
                <div className="modal-content rounded-0 p-3">
                    <button type="button" className="close closeSideModal" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title" id="addUserModalLabel">Ajouter un utilisateur</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Email *
                                    </label>
                                    <input type="email" maxLength="100" className="form-control" name="email" value={ this.props.user.email || '' } onChange={ this.handeInput } required/>
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse email valide de moins de 100 caractères.
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Accès Flash
                                    </label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="flash_access" checked={  this.props.user.flash_access == 1 } onClick={ this.handeInput } id="flash_access" />
                                        <label className="form-check-label" htmlFor="flash_access">
                                            Accordé
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Concessions
                                    </label>
                                    {dealerships}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className='btn btn-primary float-right' onClick={()=> this.props.onSubmit()}>
                            <li className='fas fa-save'> </li> Enregistrer
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserForm;


// WEBPACK FOOTER //
// ./src/Components/User/UserForm.js